import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const usePickupRelayOrderInfoByFulfillmentPlanId = (fulfillmentPlanId) => {
  const pickupLocation = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'pickupLocation',
    }),
  );
  if (!pickupLocation?.pickupCarrierId && !pickupLocation?.pickupLocationId) {
    return null;
  }
  return pickupLocation;
};

export const usePickupRelayOrderInfoBySalesOrderId = (salesOrderId) => {
  const fulfillmentPlanIds = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanIdsBySalesOrderIds(state, {
      salesOrderIds: [salesOrderId],
    }),
  );
  return usePickupRelayOrderInfoByFulfillmentPlanId(fulfillmentPlanIds[0]);
};

export const useIsPickupRelayOrderByFulfillmentPlanId = (fulfillmentPlanId) => {
  return !!usePickupRelayOrderInfoByFulfillmentPlanId(fulfillmentPlanId);
};
